import { render, staticRenderFns } from "./InvestmentsResourceList.vue?vue&type=template&id=205ac41a&scoped=true"
import script from "./InvestmentsResourceList.vue?vue&type=script&lang=js"
export * from "./InvestmentsResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ac41a",
  null
  
)

export default component.exports